import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Spinner from "../../../Layouts/Spinner";

import { addColorValidation, addSizeValidation } from "../../../Constant/constant";
import { addSize } from "../../../../redux/size/action";
import { addColor } from "../../../../redux/color/action";

const AddColor = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      status: 1,
      name: "",
      ar_name: "",
      hex_code: "#000000",
    },
    validationSchema: addColorValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    dispatch(addColor(values, setLoading, navigate));
  };

  const handleChangeStatus = (e) => {
    formik.setFieldValue("status", Number(e.target.value));
  };

  console.log(formik.values, "sdfsfs");

  return (
    <div className=" card-head order-card order-timing">
      <div className="sub-head">
        <h4>Add Color</h4>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="row product-row">
          <div className="col-md-3">
            <div style={{ position: 'sticky', top: '0' }} className="add-category-row d-flex flex-column">

              <div className="add-category-wrapper ">
                <div className="addcategory-padding">
                  <label>Status</label>
                  <select
                    className="form-control"
                    onChange={handleChangeStatus}
                    onBlur={formik.handleBlur}
                    value={formik.values.status}
                  >
                    <option value="">Select Status</option>
                    <option value="1">Active</option>
                    <option value="2">Inactive</option>
                  </select>
                  {formik.touched.status && formik.errors.status ? (
                    <div className="error">{formik.errors.status}</div>
                  ) : null}
                </div>
              </div>
              <div className="add-category-wrapper ">
                <div className="addcategory-padding">
                  <label>Hexa Code (Select Color)</label>
                  <div className="d-flex align-items-center">
                    <input
                      type="color"
                      className="form-control"
                      name="hex_code"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.hex_code}
                      style={{
                        width: "520px",
                        height: "80px",
                        border: "none",
                        cursor: "pointer",
                        borderRadius: "15px",
                      }}
                    />
                    {formik.touched.hex_code && formik.errors.hex_code ? (
                      <div className="error">{formik.errors.hex_code}</div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div className="col-md-9 ">
            <div className=" form-group">
              <label>Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter name"
                name="name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.name}
              />
              {formik.touched.name && formik.errors.name ? (
                <div className="error">{formik.errors.name}</div>
              ) : null}
            </div>
            <div className=" form-group">
              <label>Ar Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter ar name"
                name="ar_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.ar_name}
              />
              {formik.touched.ar_name && formik.errors.ar_name ? (
                <div className="error">{formik.errors.ar_name}</div>
              ) : null}
            </div>
            <div
              className="d-flex align-items-center justify-content-between back-update"
              style={{ columnGap: "20px" }}
            >
              <button
                className="back-btn"
                onClick={() => navigate("/color")}
                style={{ width: "max-content" }}
              >
                Back
              </button>
              <button
                className="submit-btn"
                style={{ width: "max-content" }}
                type="submit"
              >
                {!loading ? "Submit" : <Spinner />}
              </button>
            </div>

          </div>







        </div>


      </form>
    </div>
  );
};

export default AddColor;
